import React from 'react';
import { BrowserRouter, Routes, Route, NavLink } from 'react-router-dom';

import Dashboard from './pages/Dashboard';
import Products from './pages/Products';
import Claims from './pages/Claims';
import Pool from './pages/Pool';
import WalletButton from './components/WalletButton';

const NAV = [
  { to: '/', label: 'Dashboard' },
  { to: '/products', label: 'Products' },
  { to: '/claims', label: 'Claims' },
  { to: '/pool', label: 'Pool' },
];

export default function App() {
  return (
    <BrowserRouter>
      <div className="insurance-app">
        {/* ── Top Bar ── */}
        <header className="insurance-topbar">
          <span className="insurance-brand">🛡️ AGENTUMI Insurance</span>
          <nav className="insurance-nav">
            {NAV.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                end={n.to === '/'}
                className={({ isActive }) =>
                  'insurance-nav-link' + (isActive ? ' active' : '')
                }
              >
                {n.label}
              </NavLink>
            ))}
          </nav>
          <a
            href="https://market.agentumi.xyz"
            target="_blank"
            rel="noreferrer"
            className="insurance-external-link"
          >
            Market ↗
          </a>
          <WalletButton />
        </header>

        {/* ── Pages ── */}
        <main className="insurance-container">
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/products" element={<Products />} />
            <Route path="/claims" element={<Claims />} />
            <Route path="/pool" element={<Pool />} />
          </Routes>
        </main>

        {/* ── Footer ── */}
        <footer className="insurance-footer">
          <div className="insurance-footer-inner">
            <span className="insurance-footer-brand">AGENTUMI</span>
            <div className="insurance-footer-links">
              <a href="https://market.agentumi.xyz">Market</a>
              <a href="https://agu.agentumi.xyz">AGU</a>
              <a href="https://ledger.agentumi.xyz">Ledger</a>
              <a href="https://finance.agentumi.xyz">Finance</a>
              <a href="https://doc.agentumi.xyz">Docs</a>
              <a href="https://github.com/softkid/agentumi">GitHub</a>
            </div>
            <span className="insurance-footer-copy">© 2026 AGENTUMI</span>
          </div>
        </footer>
      </div>
    </BrowserRouter>
  );
}
